import { QuoteTasksService, type Workscope } from "@common/client"
import { makeQuery } from "../utils"

export const labourBaseKey = ["labour"] as const

export const quoteTaskLabourQuery = makeQuery({
  serviceCall: QuoteTasksService.estimateLabour,
  staleTime: 5 * 60 * 1000,
  queryKey: ({ quote_task_id, aircraft_type_ids, same_aircraft_type }) => [
    ...labourBaseKey,
    quote_task_id,
    aircraft_type_ids ?? [],
    same_aircraft_type ?? true,
  ],
})

export const priceHistoryBaseKey = ["quote-task-price-history"] as const

export const priceHistoryKey = (taskId: string) =>
  [...priceHistoryBaseKey, taskId] as const

export const avrefPricesBaseKey = ["avref-prices"] as const

export const avrefPricesKey = (chargeId: string) =>
  [...avrefPricesBaseKey, chargeId] as const

export const quoteTaskPriceHistoryQuery = makeQuery({
  serviceCall: QuoteTasksService.getPriceHistory,
  queryKey: ({ quote_task_id }) => priceHistoryKey(quote_task_id),
})

export const partSuggestionsBaseKey = ["quote-task-part-suggestions"] as const

export const partSuggestionsKey = (taskId: string, prefix: string) =>
  [...partSuggestionsBaseKey, taskId, prefix] as const

export const quoteTaskPartSuggestionsQuery = makeQuery({
  serviceCall: QuoteTasksService.suggestParts,
  queryKey: ({ quote_task_id, prefix }) =>
    partSuggestionsKey(quote_task_id, prefix ?? ""),
})

export const taskPackagesBaseKey = ["quote-task-similar-packages"] as const

export const taskPackagesKey = (taskId: string, kind: Workscope) =>
  [...taskPackagesBaseKey, taskId, kind] as const

export const quoteTaskPackagesQuery = makeQuery({
  serviceCall: QuoteTasksService.findSimilarPackages,
  queryKey: ({ quote_task_id, kind }) => taskPackagesKey(quote_task_id, kind),
})

export const cannedTasksBaseKey = ["quote-task-canned-tasks"] as const

export const cannedTasksKey = (taskId: string) =>
  [...cannedTasksBaseKey, taskId] as const

export const quoteTaskCannedTasksQuery = makeQuery({
  serviceCall: QuoteTasksService.searchCannedTasks,
  queryKey: ({ quote_task_id }) => cannedTasksKey(quote_task_id),
})

export const pastPartsBaseKey = ["quote-task-past-parts"] as const

export const quoteTaskPastPartsQuery = makeQuery({
  serviceCall: QuoteTasksService.listPastParts,
  queryKey: ({ quote_task_id }) => [...pastPartsBaseKey, quote_task_id],
})
